/*
 * MediaGallery.jsx
 * Created by Destin Frasier on 03/27/18
 */

import React from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';

import * as Icons from './icons/Icons';
import MediaGalleryModal from './MediaGalleryModal';

const PHOTO_GALLERY_EXPORT = PropTypes.shape({
    photo_gallery_image: PropTypes.string,
    photo_gallery_image_alt: PropTypes.string,
    photo_gallery_location: PropTypes.string
});

const propTypes = {
    mediaItems: PropTypes.arrayOf(PHOTO_GALLERY_EXPORT),
    displayThumbnail: PropTypes.bool
};

const defaultProps = {
    mediaItems: [],
    displayThumbnail: true
};

export class MediaGallery extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            showGallery: false,
            activeIndex: 0,
            triggerId: ''
        };
    }

    openModal = (activeIndex, triggerId) => {
        this.setState({
            activeIndex,
            triggerId: `media-block-${triggerId}`,
            showGallery: true
        });
    }
    
    closeModal = () => {
        this.setState({
            showGallery: false
        });

        window.setTimeout(() => {
            document.getElementById(this.state.triggerId).focus();
        }, 0);
    }

    generateMediaBlocks(mediaItems) {
        const mediaBlocks = mediaItems.map((mediaItem, index) => (
            <li key={`${uniqueId(mediaItem.photo_gallery_image)}`}>
                <button
                    id={`media-block-${index}`}
                    className="rec-media-gallery-link-block"
                    onClick={() => this.openModal(index, index)}>
                    <img
                        src={mediaItem.photo_gallery_image}
                        alt={mediaItem.photo_gallery_image_alt} />
                </button>
                
            </li>
        ));

        mediaBlocks.push(
            <li
                className="rec-media-gallery-more"
                key="rec-media-gallery-more">
                <button
                    className="rec-media-gallery-link-block"
                    id="media-block-all"
                    onClick={() => this.openModal(0, 'all')}>
                    <Icons.IconCamera />
                    <div>
                        View all {mediaItems.length} photos
                    </div>
                </button>
            </li>
        );

        return mediaBlocks;
    }

    generateImages(images) {
        return images.map((image) => ({
            url: image.photo_gallery_image,
            title: image.photo_gallery_image_alt
        }));
    }

    render() {
        const { mediaItems } = this.props;

        // Remove images that don't have source and alt text
        const cleanMedia = mediaItems.filter((mediaItem) => (
            mediaItem.photo_gallery_image !== null
            && mediaItem.photo_gallery_image_alt !== null
            && mediaItem.photo_gallery_location !== null));

        // Generate up to 5 preview images
        const mediaBlocks = this.generateMediaBlocks(cleanMedia.slice(0, 5));

        // Format media to fit the Gallery component
        const images = cleanMedia.map((image) => ({
            url: image.photo_gallery_image,
            title: image.photo_gallery_image_alt,
            byline: image.photo_gallery_location
        }));

        return (
            <div className="rec-media-gallery">
                <h3>Media Gallery</h3>
                <ul className="rec-media-gallery-wrap">
                    {mediaBlocks}
                </ul>
                <MediaGalleryModal
                    mediaItems={images}
                    isOpen={this.state.showGallery}
                    onRequestClose={this.closeModal}
                    activeIndex={this.state.activeIndex}
                    displayThumbnail={this.props.displayThumbnail} />
            </div>
        );
    }
}

MediaGallery.propTypes = propTypes;
MediaGallery.defaultProps = defaultProps;

export default MediaGallery;
